"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchFilterOuterContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ManagerSearchFilterOuterContainer = styled_components_1.default.div `
  display: inline-block;
  vertical-align: top;
  position: relative;
  margin-left: 2px;
`;
//# sourceMappingURL=search-filter-outer-container.js.map